export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13984.af63f181.jpg";